import { render, staticRenderFns } from "./electricity-dialog.vue?vue&type=template&id=3c835a74&scoped=true"
import script from "./electricity-dialog.vue?vue&type=script&lang=js"
export * from "./electricity-dialog.vue?vue&type=script&lang=js"
import style0 from "./electricity-dialog.vue?vue&type=style&index=0&id=3c835a74&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c835a74",
  null
  
)

export default component.exports